// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-account-button {
  background-color: rgba(170, 195, 219, 0.171);
  padding: 1%;
  margin: 10px;
  border-radius: 20px;
  border: rgb(27, 51, 129);
  border-width: 2px;
  border-style: solid;
}

.create-account-button:hover {
  background-color: rgba(170, 195, 219, 0.575);
  padding: 1%;
  margin: 10px;
  border-radius: 20px;
  cursor: pointer;
}

.login-page-container {
  width: 300px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(220, 224, 255);
  padding:10px;
  border-radius: 5px;
}

.create-account-page-container {
  max-width: 50%;
  flex:1 1;
  background-color: rgba(22, 80, 22, 0.1);
  border-radius: 20px;
  margin:10px;
}
 @media(max-width: 500px) {
  .create-account-page-container {
    max-width: 80%;
  }
 }

.login-page-parent-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex:1 1;

}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,QAAM;EACN,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;AACb;CACC;EACC;IACE,cAAc;EAChB;CACD;;AAED;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,QAAM;;AAER","sourcesContent":[".create-account-button {\n  background-color: rgba(170, 195, 219, 0.171);\n  padding: 1%;\n  margin: 10px;\n  border-radius: 20px;\n  border: rgb(27, 51, 129);\n  border-width: 2px;\n  border-style: solid;\n}\n\n.create-account-button:hover {\n  background-color: rgba(170, 195, 219, 0.575);\n  padding: 1%;\n  margin: 10px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.login-page-container {\n  width: 300px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgb(220, 224, 255);\n  padding:10px;\n  border-radius: 5px;\n}\n\n.create-account-page-container {\n  max-width: 50%;\n  flex:1;\n  background-color: rgba(22, 80, 22, 0.1);\n  border-radius: 20px;\n  margin:10px;\n}\n @media(max-width: 500px) {\n  .create-account-page-container {\n    max-width: 80%;\n  }\n }\n\n.login-page-parent-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex:1;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
